// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchFormRecurrence {\n  margin-top: 20px;\n  padding-bottom: 80px;\n}\n", "",{"version":3,"sources":["webpack://./src/views/Search/SearchMobile/SearchFormRecurrence/_style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".SearchFormRecurrence {\n  margin-top: 20px;\n  padding-bottom: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
